import { PATIENT_WAITING_LIST } from "@/api_framework/api_config";
import {
  IAtHomeBookingStatusSummaryParamsBody,
  IAtHomeBookingStatusSummaryResponse,
} from "@/api_framework/api_modals/Patients";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import { setAtHomePatientWaitingStats } from "@/app_redux/reducers/slices/auth/patient_waiting_list_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import { useAPIUtils } from "../../useAPIUtils";
import { useConfiguration } from "../../useConfiguration";

AxiosCurlirize(axios, () => {});

export const useAtHomeBookingStatusSummaryAPI = () => {
  const dispatch = useAppDispatch();
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();

  const execute = useCallback(
    async (payload: IAtHomeBookingStatusSummaryParamsBody) => {
      dispatch(
        setLoading({
          key: "isAtHomeServicesStatsInProgress",
          status: true,
        }),
      );

      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: AxiosResponse<IAtHomeBookingStatusSummaryResponse> = await axios.post(
          PATIENT_WAITING_LIST?.AT_HOME_BOOKING_STATUS_SUMMARY?.baseURL ?? "",
          payload,
          {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          },
        );

        if (response.data.status === true) {
          dispatch(
            setAtHomePatientWaitingStats({
              data: Array.isArray(response.data.data) ? response.data.data : [],
            }),
          );
        } else {
          dispatch(
            setAtHomePatientWaitingStats({
              data: [],
            }),
          );
        }
      } catch (error) {
        const axiosError = error as AxiosError;
        captureError(axiosError);
        sendCurl((axiosError.config as any)?.curlCommand);
        dispatch(
          setAtHomePatientWaitingStats({
            data: [],
          }),
        );
      } finally {
        dispatch(
          setLoading({
            key: "isAtHomeServicesStatsInProgress",
            status: false,
          }),
        );
      }
    },
    [captureError, configuration.localStorage.ACCESS_TOKEN.key, dispatch, sendCurl],
  );

  return execute;
};
